import { render, staticRenderFns } from "./DriverStatement.vue?vue&type=template&id=b6f15b7c&scoped=true"
import script from "./DriverStatement.vue?vue&type=script&lang=js"
export * from "./DriverStatement.vue?vue&type=script&lang=js"
import style0 from "./DriverStatement.vue?vue&type=style&index=0&id=b6f15b7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f15b7c",
  null
  
)

export default component.exports